<template>
  <b-container fluid>
    <!-- <b-row>
      <b-col class="bg-title">
        <h4><font color="ffffff">Configuración del usuario</font></h4>
      </b-col>
    </b-row> -->
    <b-row align-h="center">
      <b-col cols="12" md="11" class="card-form-primary mt-5 ">
        <b-row>
          <b-col class="mt-3 mb-2">
            <h5 style="color: #312bb5; text-transform:capitalize;"><b-icon icon="files"/> Configuración</h5>
          </b-col>         
        </b-row>
        <UsuarioConfig/>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import UsuarioConfig from '@/components/configuracion/UsuarioConfig.vue'

  export default {
    components: {
      UsuarioConfig
    },
    data() {
      return {
        
      }
    },
    mounted(){
      if(window.matchMedia("(max-width: 768px)").matches){
        this.$store.commit("updateIsShowSideCobro", false);
      }
      window.scrollTo(0, 0);
    },
    methods: {
        
    }
  }
</script>